import { createRouter, createWebHistory } from 'vue-router'
import InteractiveMapView from '../views/InteractiveMapView.vue'
const routes = [
  {
    path: '/',
    name: 'interactive-map',
    component: InteractiveMapView
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
export default router